import { render, staticRenderFns } from "./ProcedureWhList.vue?vue&type=template&id=0065eb3e&"
import script from "./ProcedureWhList.vue?vue&type=script&lang=js&"
export * from "./ProcedureWhList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports